const defaultUserAlternatives: string =
  '??????????????????????????????????????????????????????????????????????????????????????????'

const defaultResponses: string =
  '                                                                                          '

const sisuCard = {
  title: 'Quer simular o SISU?',
  description:
    'Utilize as notas com TRI e simule as suas chances de entrar na universidade com nosso simulador do SISU.',
  buttonLabel: 'CLIQUE AQUI!'
}

const testColors = [
  {
    key: 'amarela',
    title: 'Amarela'
  },
  {
    key: 'azul',
    title: 'Azul'
  },
  {
    key: 'branca',
    title: 'Branca'
  },
  {
    key: 'verde',
    title: 'Verde'
  }
]

const testLanguages = [
  {
    key: 'ingles',
    title: 'Inglês'
  },
  {
    key: 'espanhol',
    title: 'Espanhol'
  }
]

const alternatives = ['A', 'B', 'C', 'D', 'E']

export const data = {
  defaultUserAlternatives,
  defaultResponses,
  alternatives,
  sisuCard,
  testColors,
  testLanguages
}
